import { createContext, lazy, Suspense, useState, type ReactNode } from 'react';

import { queryClient } from '@/queryClient.ts';

import { getRegisterSourceData } from './analytics/registerSource.ts';
import { flagsQuery } from './flags.ts';

const loadDialog = () => import('./in-app-gate-dialog.tsx');
const InAppGateDialog = lazy(loadDialog);

// oxlint-disable-next-line react/only-export-components
export const InAppGateContext = createContext<{
  /** Will show "open in browser" instructions if conditions are met. */
  isInAppBrowser: () => Promise<boolean>;
}>(undefined!);

export const InAppGateProvider: React.FC<{ children?: ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const isInAppBrowser = async (): Promise<boolean> => {
    const r = getRegisterSourceData();
    if (r.is_in_app_browser) {
      // Start fetching the dialog in parallel with flags so it can show without delay
      void loadDialog();
      const flags = await queryClient.query(flagsQuery());
      if (flags.tiktokInAppGateKValues.includes(r.params.k)) {
        setIsOpen(true);
        return true;
      }
    }
    return false;
  };

  return (
    <InAppGateContext.Provider value={{ isInAppBrowser }}>
      {isOpen && (
        <Suspense>
          <InAppGateDialog />
        </Suspense>
      )}
      {children}
    </InAppGateContext.Provider>
  );
};
